import React, { Fragment } from 'react';

import ArticleDetailsBreadcrumb from './ArticleDetailsBreadcrumb';
import ArticleDetailsHeader from './ArticleDetailsHeader';
import ArticleDetailsFooter from './ArticleDetailsFooter';

import { ARTICLES } from '../Articles/Articles';
import './SG006.scss';

const SG006 = () => {
  const permalink = 'what-is-better-for-myopia-control-glasses-or-contact-lens';
  const article = ARTICLES?.find(article => article?.permalink === permalink);
  const baseImageUrl = 'https://static.lenskart.com/owndays/img/articles/sg-006';

  return (
    <Fragment>
      <ArticleDetailsBreadcrumb article={article} />

      <div className="article-details">
        <ArticleDetailsHeader article={article} />

        <div className="article-details__content">
          <div className="article-details__container">
            <p>
              {article.description.split('\n').map((line, index) => (
                <Fragment key={index}>
                  {line}
                  <br />
                </Fragment>
              ))}
            </p>

            <div>
              <h2>How Comfortable Are Glasses to Wear and Remove?</h2>
              <p className="p-img-small">
                <img
                  alt="How Comfortable Are Glasses to Wear and Remove?"
                  loading="lazy"
                  src={`${baseImageUrl}/illust-1.svg`}
                />
              </p>

              <p>
                Glasses are often the go-to for comfort when it comes to myopia correction. They’re
                easy to wear and remove, with no need to worry about inserting lenses or cleaning
                them like you would with contact lenses. This makes glasses an excellent option for
                younger children who might struggle with handling contacts. Plus, since glasses
                don’t touch the eyes directly, they reduce the risk of irritation or infection.
                Glasses or contacts for myopia have advantages, but glasses often take the lead for
                comfort and convenience.
              </p>

              <div className="button-group">
                <a className="button button--primary" href="/sg/en/eyewear/eyeglasses.html">
                  See All Glasses
                </a>
              </div>
            </div>

            <div>
              <h2>Can Glasses Help Slow Down Myopia Progression?</h2>
              <p className="sg006__img-glasses-myopia-info">
                <img
                  alt="Can Glasses Help Slow Down Myopia Progression?"
                  loading="lazy"
                  src={`${baseImageUrl}/illust-2.svg`}
                />
              </p>

              <p>
                Glasses aren’t just about helping you see clearly; they can also play a role in
                slowing down the progression of myopia. Research has shown that certain types of
                myopia lenses can reduce the rate of myopia progression by 15% to 30%. This is
                particularly helpful for children, as managing the condition early can prevent it
                from worsening as they grow. If you're looking for a straightforward way to manage
                myopia, getting prescription glasses online offers an easy and accessible solution
                for families seeking quality eyewear to help with myopia control.
              </p>

              <a className="article-details__card" href="/sg/en/news/free-myopia-control-2-lenses">
                <img
                  alt="Free upgrade* to Myopia Control 2 lenses for children aged 14 and below"
                  loading="lazy"
                  src={`${baseImageUrl}/free-myopia.webp`}
                />
                <p>
                  Free upgrade* to Myopia Control 2 lenses for children aged 14 and below
                  <br />
                  <small>*Term & conditions apply</small>
                </p>
                <svg viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg">
                  <path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z" />
                </svg>
              </a>
            </div>

            <div>
              <h2>How Do Contact Lenses Control Myopia?</h2>
              <p className="p-img-single">
                <img
                  alt="How Do Contact Lenses Control Myopia?"
                  loading="lazy"
                  src={`${baseImageUrl}/main-2.webp`}
                />
              </p>

              <p>
                When it comes to controlling myopia, contact lenses can offer a real advantage over
                glasses in some cases. Specially designed myopia control lenses, like
                orthokeratology, can slow myopia progression by up to 40% or more. These lenses,
                either worn daily or overnight, gently reshape the cornea to help prevent the eye
                from becoming more myopic. For those looking for a more effective way to manage
                short-sightedness, contact lenses may be the better option, offering long-term
                results that glasses alone can’t always match.
              </p>
            </div>

            <div>
              <h2>What Are the Benefits of Contact Lenses for Myopia Control?</h2>
              <p>
                Contact lenses can be a game-changer when it comes to myopia control. Because they
                sit directly on the eye, they provide a more natural, uninterrupted field of vision
                compared to glasses. They’re also much less likely to fog up or get splashed, making
                them perfect for active kids or adults who are always on the go. Many contact lenses
                are specially designed to slow down myopia progression, offering a more personalised
                solution for managing short-sightedness. In short, contacts can be a smart,
                practical choice for those looking for effective myopia control.
              </p>
            </div>

            <div>
              <h2>What Is the Best Option for Children with Myopia?</h2>
              <p className="p-img-single">
                <img
                  alt="What Is the Best Option for Children with Myopia?"
                  loading="lazy"
                  src={`${baseImageUrl}/main-3.webp`}
                />
              </p>
              <p>
                When it comes to kids, glasses or contacts for myopia offer their own set of
                benefits. Eyeglasses are often the first choice for younger children because they’re
                simple to wear and comfortable. They don’t require much maintenance, and kids
                usually find them easy to manage.
                <br />
                However, as children grow older and become more responsible, contact lenses may be a
                better option. They provide stronger control over myopia progression, but they do
                require more care and attention. Contact lenses are also an excellent choice for
                active kids who prefer the freedom and convenience of lenses.
                <br />
                The decision between glasses or contacts for myopia depends on your child’s age,
                lifestyle, and how well they can manage lenses. For those seeking the best glasses
                for short-sightedness, prescription glasses offer a reliable and effective solution.
                <br />
                Ultimately, the key is to choose what makes your child feel most confident and
                comfortable. To make the best decision, it’s always helpful to consult an
                optometrist who can suggest the most suitable myopia management options based on
                your child’s needs.
              </p>
            </div>

            <div>
              <h2>Make the Right Choice for Myopia Control</h2>
              <p className="p-img-single">
                <img
                  alt="Make the Right Choice for Myopia Control"
                  loading="lazy"
                  src={`${baseImageUrl}/main-4.webp`}
                />
              </p>

              <p>
                Choosing between glasses or contacts for myopia isn’t just about vision correction.
                It’s about finding what works best for daily life. Some people prefer the ease and
                familiarity of glasses, while others appreciate the freedom and enhanced myopia
                control that contact lenses provide. The right choice depends on personal comfort,
                lifestyle, and long-term eye health goals. For high-quality prescription lenses and
                expert guidance, visit the best optical shop in Singapore: OWNDAYS.
                <br />
                Our experienced team can help you find a solution tailored to your vision needs,
                ensuring clear sight and effective myopia management. Visit any of our outlets today
                to find the perfect eyewear for your family’s needs.
              </p>
            </div>

            <div className="button-group button-group--2">
              <a className="button button--primary" href="/sg/en/eyewear/eyeglasses.html">
                See All Eyeglasses
              </a>
              <a className="button button--primary" href="/sg/en/bookeyetest">
                Book Free Eye Test
              </a>
            </div>

            <div className="article-details__customer-guarantees">
              <div className="article-details__customer-guarantees-flex">
                <img
                  alt="Peace Of Mind icon"
                  loading="lazy"
                  src="https://static.lenskart.com/owndays/img/articles/icons/peace-of-mind.svg"
                />
                <div className="article-details__customer-guarantees-flex-text">
                  <h3>OWNDAYS Customer Guarantees</h3>
                  <p>
                    Proper care and regular maintenance can extend the lifespan of your spectacles.
                    OWNDAYS offers you the most comprehensive after-sales service in the optical
                    industry so you can enjoy your OWNDAYS spectacles at all times.
                  </p>
                </div>
              </div>
              <a className="article-details__button-group-3" href="/sg/en/services/warranty">
                More Details
              </a>
            </div>

            <div className="button-group button-group--2">
              <a className="button button--primary" href="/sg/en/eyewear/eyeglasses.html">
                See All Eyeglasses
              </a>
              <a className="button button--primary" href="/stores/sg">
                Search For Nearest OWNDAYS Stores
              </a>
            </div>
          </div>
        </div>

        <ArticleDetailsFooter permalink={permalink} />
      </div>
    </Fragment>
  );
};

export default SG006;
